import links from "../routes/links";
import { ICMSDocument } from "./common/cmsSchema";

export const termsOfUse: ICMSDocument = {
    title: "Terms of Use",
    effectiveDate: "Effective Date: February 1, 2023",
    content: [
        {
            content: [
                {
                    text: "These Terms of Use (“",
                },
                {
                    text: "Terms",
                    bold: true
                },
                {
                    text: "”) apply to your use of (i) the DaVinci Lock, LLC (“",
                },
                {
                    text: "DaVinci",
                    bold: true
                },
                {
                    text: ",” “",
                },
                {
                    text: "us",
                    bold: true
                },
                {
                    text: "” “",
                },
                {
                    text: "we",
                    bold: true
                },
                {
                    text: ",” or “",
                },
                {
                    text: "our",
                    bold: true
                },
                {
                    text: ",”) web sites made available by us, including without limitation the sites located at ",
                    links: ["https://davincilock.com", "https://overlockrelease.com"]
                },
                {
                    text: " as well as any other websites we make available in the future (collectively, the “",
                },
                {
                    text: "Sites",
                    bold: true
                },
                {
                    text: "”), and our software platform (the “",
                },
                {
                    text: "Software",
                    bold: true
                },
                {
                    text: "”) that is made available to you from our Sites, as well as our apps that may be downloaded from the Apple App store and the Google Play store. Your acceptance of these Terms creates a legally binding agreement between you and DaVinci. You must accept these Terms to create a DaVinci account and to access or use the Software. If you do not have an account, and if you do not accept these terms, you may not use the Software.",
                    newline: "16px"
                },
                {
                    text: "BY CLICKING “I AGREE”, YOU ACKNOWLEDGE AND AGREE TO BE BOUND BY THESE TERMS. THESE TERMS ARE A LEGALLY BINDING AGREEMENT. IF YOU USE THE SITES AND/OR THE SOFTWARE ACTING AS THE AGENT FOR A COMPANY OR OTHER ENTITY, YOU REPRESENT THAT YOU HAVE THE LEGAL AUTHORITY TO BIND SUCH COMPANY OR ENTITY. WE RESERVE THE SOLE RIGHT AT ANY TIME TO MODIFY, DISCONTINUE, OR TERMINATE YOUR ACCESS TO THE SOFTWARE OR THE SITES, OR TO CHANGE, ADD, OR DELETE PORTIONS OF THESE TERMS WITHOUT NOTICE EXCEPT AS OTHERWISE SET FORTH HEREIN. WE WILL NOTIFY YOU OF CHANGES TO THESE TERMS VIA YOUR ACCOUNT OR BY POSTING AN UPDATED TERMS OF USE ON THE SITES. IT IS YOUR RESPONSIBILITY TO CHECK THE SITES PERIODICALLY FOR CHANGES. YOUR CONTINUED USE OF THE SITES AND SOFTWARE AFTER ANY CHANGES CONSTITUTES YOUR ACCEPTANCE OF THE REVISED TERMS. IF YOU DO NOT AGREE TO THESE TERMS, DO NOT USE THE SITES OR SOFTWARE."
                }
            ]
        },
        {
            title: "1. READ OUR PRIVACY POLICY",
            content: [
                {
                    text: "For information about our data practices, please see our ",
                    link: {
                        text: "Privacy Policy",
                        link: links.PRIVACYPOLICY.link,
                    }
                },
                {
                    text: ". By agreeing to these Terms, you agree that we can collect and use any information that you submit through the Sites or our Software in accordance with the Privacy Policy."
                }
            ]
        },
        {
            title: "2. CREATING AN ACCOUNT",
            content: [
                {
                    text: "Full use of the Software requires that you create an account by providing us with information such as your full name and a valid email address, as well as a strong password. You are responsible for all activity that occurs in association with your account. DaVinci is not liable for any loss or damages caused by your failure to maintain the confidentiality of your account credentials. Please contact us at ",
                    email: "support@davincilock.com"
                },
                {
                    text: " if you discover or suspect any security breach related to the Software or your account.",
                    newline: "8px"
                },
                {
                    text: "You represent that any information provided by you in connection with your use of the Software is accurate, complete and current, and you agree to update that information promptly if there is any change. Each account has one administrative user (the “",
                },
                {
                    text: "Owner User",
                    bold: true
                },
                {
                    text: "”). The Owner User can issue multiple user IDs for other individual users to access and use the Software and can assign permissions to each user ID (e.g., permission to only see certain facilities, etc.) You are responsible for all acts and omissions of the Owner User and each other user who is issued a User ID through the Owner User (collectively, the “",
                },
                {
                    text: "Authorized Users",
                    bold: true
                },
                {
                    text: "”). Each Authorized User must have a unique password. The Owner User as well as each person issued a User ID are responsible for keeping their User IDs and passwords secret and confidential. You agree that you are responsible for any communications, transactions or use of the Software that are made by or through your Authorized Users, together with any fees, charges, liability or other obligation that may result from such use. You are responsible for changing the password of an Authorized User if you believe that the password has been stolen or might otherwise be misused or compromised. You may not assign any of your rights under these Terms without our prior written consent, and any attempted assignment without such consent shall be void."
                }
            ]
        },
        {
            title: "3. PURCHASE OF LOCKS",
            content: [
                {
                    text: "All DaVinci Locks may be purchased through our store that can be found here ",
                    link: {
                        text: "https://davincilockstore.com",
                        link: links.STORE.href
                    }
                },
                {
                    text: ". The Software is not intended to be used without DaVinci Locks and will not work with any other locks. The terms and conditions governing your purchase of the DaVinci Locks (the “",
                },
                {
                    text: "Terms of Purchase",
                    bold: true
                },
                {
                    text: "”) are available at the online store and can be found here ",
                    link: {
                        text: "https://davincilockstore.com/policies/refund-policy",
                        link: "https://davincilockstore.com/policies/refund-policy"
                    }
                },
                {
                    text: ". The Terms of Purchase are incorporated into these Terms and you hereby agree to the Terms of Purchase by agreeing to these Terms. Full use of the Software is dependent upon your use of a computer with adequate software or a supported mobile device and Internet access. The maintenance and security of this equipment may influence the performance of the Software and it is your responsibility to ensure the equipment’s functionality and security.",
                }
            ]
        },
        {
            title: "4. POSTING YOUR CONTENT ON THE SOFTWARE",
            content: [
                    {
                        text: "DaVinci may enable you to post, upload, store, share, send, or display photos, images, video, data, text, comments, and other information and content (",
                    },
                    {
                        text: "“User Content”",
                        bold: true
                    },
                    {
                        text: ") to and via the Sites and the Software. You retain all rights to User Content that you post. By making User Content available on or through the Sites  and Software you hereby grant to DaVinci a non-exclusive, transferable, sublicensable, worldwide, perpetual, irrevocable, royalty-free license to use, copy, modify, publicly display, publicly perform, reproduce, translate, create derivative works from, and distribute your User Content, in whole or in part, in any media. The rights you grant us in this Section 4 are only for the limited purpose of offering and improving the Sites and the Software and to perform our obligations to you.",
                        newline: "16px"
                    },
                    {
                        text: "You are responsible for your User Content. You represent and warrant that you own your User Content or that you have all rights necessary to grant us a license to use your User Content as described in these Terms.",
                        newline: "16px"
                    },
                    {
                        text: "You represent and warrant that your User Content and the use and provision of your User Content on the Sites and with the Software, will not (a) infringe, misappropriate, or violate a third party’s patent, copyright, trademark, trade secret, moral rights, or other intellectual property rights, or rights of publicity or privacy; (b) violate, or encourage any conduct that would violate, any applicable law or regulation or would give rise to civil liability; (c) be fraudulent, false, misleading, or deceptive; (d) be defamatory, obscene, pornographic, vulgar, or offensive; (e) promote discrimination, bigotry, racism, hatred, harassment, or harm against any individual or group; (f) be threatening or promote violence or actions that are threatening to any person or entity; or (g) promote illegal or harmful activities or substances.",
                        newline: "16px"
                    },
                    {
                        text: "You further agree not to (1) upload any content that contains software viruses or is designed to interrupt, destroy, or limit the functionality of any equipment or services, or that contains other harmful, disruptive, or destructive files or content; (2) use or attempt to use another user’s account without authorization, or impersonate any person or entity; (3) harvest, solicit, or collect information of other users for any reason whatsoever, including, without limitation, for sending unsolicited communications; (4) post, advertise, or promote products or services commercially, or upload any content that is advertising, promotional material, junk mail, spam, or a contest or sweepstake, or that furthers or promotes criminal activity; or (5) use the Software in any manner that, in our sole discretion, is objectionable or restricts or inhibits any other person from using or enjoying the Software, or which may expose us or our users to any harm or liability of any type.",
                        newline: "16px"
                    },
                    {
                        text: "DaVinci may, in its sole discretion, alter, remove, or refuse to display any of your User Content, and may forbid you from posting, uploading, storing, sharing, sending, or displaying your User Content to and via the Software."
                    },
                ]
        },
        {
            title: "5. OUR RIGHTS",
            content: [
                {
                    text: "All content on the Sites and displayed via the Software, which is not your User Content (as defined in Section 4 above) is the proprietary property of us or our licensors and is referred to as “",
                },
                {
                    text: "DaVinci Content",
                    bold: true
                },
                {
                    text: "”. Subject to these Terms, no DaVinci Content may be modified, copied, distributed, framed, reproduced, republished, downloaded, displayed, posted, transmitted, or sold in any form or by any means, in whole or in part, without the prior written permission of us or the owner of such content. Except as otherwise set forth in these Terms, any unauthorized use of the DaVinci Content is strictly prohibited. All trademarks, logos, trade dress and service marks on the Sites are trademarks or registered trademarks of us or our licensors and may not be copied, imitated, or used, in whole or in part, without the prior written permission of us or the owner of such trademarks, logos, trade dress and service marks. The DaVinci Content includes the Software, as well as any photos, images, graphics, video, audio, data, text, comments, software, works of authorship of any kind, and other information, content, or other materials that are posted, generated, provided, or otherwise made available through the Sites or Software. The Software and its underlying technology are protected by copyright, trademark, patent, intellectual property, and other laws of the United States and foreign countries. We reserve all rights not expressly set forth in these Terms. You agree not to remove, change or obscure any copyright, trademark, service mark, or other proprietary rights notices incorporated in or accompanying the Sites or the DaVinci Content. Our logos and any other DaVinci trademarks that may appear on the Sites or in the Software, and the overall look and feel of the Software, including page headers, graphics, icons, and scripts, may not be copied, imitated or used, in whole or in part, without our prior written permission. Other trademarks, product, and service names and company names or logos mentioned on the Software are the property of their respective owners and may not be copied, imitated or used, in whole or in part, without the permission of the applicable trademark holder. You agree that you will not create any software solution that may be used to compete with the Software."
                }
            ]
        },
        {
            title: "6. YOUR USE OF THE SOFTWARE",
            content: [
                {
                    text: "The Software is intended solely for your internal business purposes. DaVinci grants you a limited, non-exclusive, non-transferable, non-sublicensable, revocable license to (1) access and use the Software, and (2) access, use, and view the DaVinci Content, in each case solely for your internal business purposes as permitted in these Terms.",
                    newline: "16px"
                },
                {
                    text: "You will not use, sublicense, copy, adapt, modify, translate, disclose, prepare derivative works based upon, distribute, license, sell, rent, lease, assign, transfer, publicly display, publicly perform, transmit, broadcast, or otherwise exploit the DaVinci Content, Software, or any portion thereof (including any third-party software), except as expressly permitted in these Terms. No licenses or rights are granted to you by implication or otherwise under any intellectual property rights owned or controlled by DaVinci or its licensors, except for the licenses and rights expressly granted in these Terms.",
                    newline: "16px"
                },
                {
                    text: "Except to the extent permitted by law, you may not perform, attempt to perform, or encourage or assist others in performing any of the following while accessing or using the Software: (1) use DaVinci’s name, any DaVinci trademark or logo, or any DaVinci proprietary information without DaVinci’s express written consent; (2) access or tamper with non-public areas of the Software, DaVinci’s computer systems, or the systems of DaVinci’s service providers; (3) test the vulnerability of any DaVinci system or breach any security or authentication measures; (4) circumvent any technological measure implemented by DaVinci or any of DaVinci’s service providers or any other third party (including another user) to protect the Software; (5) modify, decompile, disassemble, reverse engineer, tamper with, or otherwise attempt to derive the source code of the Software."
                }
            ]
        },
        {
            title: "7. FEES",
            content: [
                {
                    text: "At this time we are not charging any fees for the use of the Software. However, in the future we may charge fees, and if we elect to charge fees, we will provide you with not less than ninety (90) days prior notice of the applicable fees and payment terms. If you elect to not pay any applicable fees when due, you will no longer be able to access and use the Software and your account will be terminated."
                }
            ]
        },
        {
            title: "8. OUR ENFORCEMENT RIGHTS",
            content: [
                {
                    text: "We reserve the right (but are not required) to remove or disable your access to the Software, any DaVinci Content, or User Content at any time and without notice, and at our sole discretion, if we determine that the DaVinci Content, your User Content, or your use of the Software is objectionable or in violation of these Terms. We have the right to investigate violations of these Terms and any conduct that affects the Software, and in response may take any action we may deem appropriate."
                }
            ]
        },
        {
            title: "9. ALERTS AND NOTIFICATIONS",
            content: [
                {
                    text: "As part of your use of the Software, you may receive notifications, text messages, alerts, emails, and other electronic communications. You agree to the receipt of these communications. You can control most communications from the Software by using your account settings. We may need to provide you with certain communications, such as service announcements and administrative messages. You are responsible for any messaging or data fees you may be charged by your wireless carrier. Any notices, agreements, disclosures, or other communications that we send to you electronically will satisfy any legal communication requirements, including that the communication be in writing."
                }
            ]
        },
        {
            title: "10. THIRD PARTY COMMUNICATIONS",
            content: [
                {
                    text: "If you rely on any DaVinci Content or the Software, you do so solely at your own risk. You acknowledge and agree that the Software enables DaVinci to send text messages to renters, which include sensitive information including unlock codes. You agree that you have obtained all necessary permissions for us to send text messages to your renters. Further you agree to indemnify, defend and hold harmless DaVinci from and against any third party claims and all related damages, expenses, losses, costs, and liabilities, including reasonable attorneys’ fees, arising from or related to your use of DaVinci’s Software, including without limitation, the sending of text messages or other communications with your renters."
                }
            ]
        },
        {
            title: "11. DMCA/COPYRIGHT POLICY",
            content: [
                {
                    text: "DaVinci respects the intellectual property of others and expects its users to do the same. It is DaVinci’s policy, in appropriate circumstances and at our discretion, to disable or terminate the accounts of users who repeatedly infringe the rights of copyright holders.",
                    newline: "16px"
                },
                {
                    text: "If you are a copyright owner or an agent thereof and believe that any User Content or DaVinci Content infringes upon your copyrights, you may submit a notification pursuant to the Digital Millennium Copyright Act (“",
                },
                {
                    text: "DMCA",
                    bold: true
                },
                {
                    text: "”) by providing our Copyright Agent with the following information in writing (see 17 U.S.C 512(c)(3) for further detail):",
                    newline: "16px"
                },
                {
                    text: "(i) A physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is allegedly infringed;",
                    newline: "0"
                },
                {
                    text: "(ii) Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works at a single online site are covered by a single notification, a representative list of such works at that site;",
                    newline: "0"
                },
                {
                    text: "(iii) Identification of the material that is claimed to be infringing or to be the subject of infringing activity and that is to be removed or access to which is to be disabled and information reasonably sufficient to permit the service provider to locate the material;",
                    newline: "0"
                },
                {
                    text: "(iv) Information reasonably sufficient to permit us to contact you, such as an address, telephone number, and, if available, an electronic mail address;",
                    newline: "0"
                },
                {
                    text: "(v) A statement that you have a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law; and",
                    newline: "0"
                },
                {
                    text: "(vi) A statement that the information in the notification is accurate, and under penalty of perjury, that you are authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.",
                    newline: "16px"
                },
                {
                    text: "Our designated Copyright Agent to receive notifications of claimed infringement relating to User Content or DaVinci Content is: Copyright Agent, DaVinci Lock, Maggie Bode, info@davincilock.com. Only DMCA notices and notices relating to complaints in connection with claimed infringement relating to User Content and DaVinci Content should go to the Copyright Agent; any other feedback, comments, requests for technical support, and other communications should be sent via email to ",
                    email: "support@davincilock.com"
                },
                {
                    text: "."
                }
            ]
        },
        {
            title: "12. FEEDBACK AND SUBMISSIONS POLICY",
            content: [
                {
                    text: "If you submit comments, ideas, or feedback to us, you agree that we can use, disclose, reproduce, distribute, and exploit them without any restriction or compensation to you. We do not waive any rights to use similar or related ideas or feedback previously known to us, developed by DaVinci, or obtained from sources other than you."
                }
            ]
        },
        {
            title: "13. LINKING TO OTHER WEBSITES",
            content: [
                {
                    text: "The Sites and the Software may display or permit linking or other access to or use of third-party content, promotions, websites, apps, services and resources (collectively “",
                },
                {
                    text: "Third-Party Software",
                    bold: true
                },
                {
                    text: "”) that are not under DaVinci’s control. We provide these links only as a convenience and are not responsible for the products, services, or other content that are available from Third-Party Software. You acknowledge that any Third-Party Software that you use in connection with the Sites or the Software are not part of the Sites or the Software and are not controlled by DaVinci, and you take sole responsibility and assume all risk arising from your interaction with or use of any Third-Party Software. You also acknowledge that these Terms and the DaVinci Privacy Policy do not apply to any Third-Party Software. You are responsible for reading and understanding the terms and conditions and privacy policy that applies to your use of any Third-Party Software."
                }
            ]
        },
        {
            title: "14. CHANGES TO THE SOFTWARE",
            content: [
                {
                    text: "DaVinci, in its sole discretion, may change or discontinue, temporarily or permanently, any feature, component, or content of the Software at any time without notice. DaVinci is not liable to you or to any third party for any modification, suspension, or discontinuance of any feature, component, or content of the Software. We reserve the right to determine the timing and content of Software updates, which may be automatically downloaded and installed by DaVinci without prior notice to you."
                }
            ]
        },
        {
            title: "15. SUPPORT AND AVAILABILITY",
            content: [
                {
                    text: "DaVinci provides support via email available at [",
                    email: "support@davincilock.com"
                },
                {
                    text: "]. Email inquiries will be responded to within 1-hour during regular business hours 8AM - 6PM ET Monday - Friday. DaVinci will use good faith efforts to provide 100% availability for the Sites and the Software, but cannot guarantee such availability due to the complexity of integrating multiple technology platforms and events beyond the reasonable control of DaVinci. DaVinci disclaims any liability for any losses, costs, or expenses incurred by you due to the unavailability of the Sites or the Software."
                }
            ]
        },
        {
            title: "16. API LICENSE",
            content: [
                {
                    text: "DaVinci, in its sole discretion, may make its API available to you. You agree that your use of the DaVinci API will be subject in all events to these Terms and the API License attached hereto as ",
                },
                {
                    text: "Exhibit A",
                    underline: true
                },
                {
                    text: ". In the event of any conflict between these Terms and the terms and conditions in the API License, the terms and conditions of these Terms shall control."
                }
            ]
        },
        {
            title: "17. PROCESSING OF EUROPEAN UNION RESIDENT PERSONAL DATA",
            content: [
                {
                    text: "DaVinci may at times provide services to a company or other entity (“",
                },
                {
                    text: "Client",
                    bold: true
                },
                {
                    text: "”) located in the European Union (“",
                },
                {
                    text: "EU",
                    bold: true
                },
                {
                    text: "”). With respect to information relating to an identified or identifiable natural person in the EU that DaVinci receives from a Client (“",
                },
                {
                    text: "Personal Data",
                    bold: true
                },
                {
                    text: "”), DaVinci shall be regarded as a “",
                },
                {
                    text: "Processor",
                    bold: true
                },
                {
                    text: ",” and the Client shall be regarded as a “",
                },
                {
                    text: "Controller",
                    bold: true
                },
                {
                    text: ".” With respect to Processing of Personal Data covered by the General Data Protection Regulation (“",
                },
                {
                    text: "GDPR",
                    bold: true
                },
                {
                    text: "”), or other law regarding the collection, use, disclosure, or security of Personal Data (“",
                },
                {
                    text: "Data Protection Laws and Regulations",
                    bold: true
                },
                {
                    text: "”), DaVinci and Client shall have the obligations set forth in the Data Processing Addendum attached to these Terms as ",
                },
                {
                    text: "Exhibit B",
                    underline: true
                },
                {
                    text: " (the “",
                },
                {
                    text: "DPA",
                    bold: true
                },
                {
                    text: "”). All capitalized terms in the DPA not otherwise defined in these Terms shall have the same meaning as provided by GDPR."
                }
            ]
        },
        {
            title: "18. TERMINATION",
            content: [
                {
                    text: "We reserve the right to suspend or deactivate your account or your access to the Software, or to terminate these Terms, at our sole discretion, at any time and without notice. Upon any such suspension, deactivation, or termination, we may delete or remove User Content and other information related to your account. You may close your account at any time by contacting us at ",
                    email: "support@davincilock.com"
                },
                {
                    text: ". Upon any termination of these Terms or suspension, termination, or discontinuation of the Software or your account, the following provisions of these Terms will survive: Sections 1, 3, 4, 5, 6, 10, 11, 12, 13, 16, 17, 18, 19, 20, 21, 22, 23 and 24."
                }
            ]
        },
        {
            title: "19. DISCLAIMERS",
            content: [
                {
                    text: "THE SOFTWARE AND DAVINCI CONTENT ARE PROVIDED “AS IS,” WITHOUT WARRANTY OF ANY KIND. WITHOUT LIMITING THE FOREGOING, WE EXPLICITLY DISCLAIM ALL EXPRESS OR IMPLIED WARRANTIES ARISING OUT OF OR RELATED TO THESE TERMS OR THE SOFTWARE, INCLUDING ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT OR NON-INFRINGEMENT, AND ANY WARRANTIES ARISING OUT OF COURSE OF DEALING OR USAGE OF TRADE. We make no warranty that the Software or DaVinci Content will meet your requirements or be available on an uninterrupted, secure, or error-free basis. We make no warranty regarding the quality, accuracy, timeliness, truthfulness, completeness, or reliability of the Software, any DaVinci Content, or any data or results you obtain by using the Software."
                }
            ]
        },
        {
            title: "20. INDEMNITY",
            content: [
                {
                    text: "You will indemnify and hold harmless DaVinci and its officers, directors, employees, affiliates, agents, licensors, and contractors from and against any claims, suits, actions, demands, disputes, allegations, or investigations brought by any third party, governmental authority, or industry body, and all liabilities, damages, losses, costs, and expenses, including without limitation reasonable attorneys’ fees, arising out of or in any way connected with (i) your access to or use of the Software, (ii) your User Content, (iii) your breach or alleged breach of any warranties made by you hereunder or your violation of any other provision of these Terms, (iv), your negligence, or (v) your violation of any law or the rights of a third-party. We reserve the right to assume control of the defense of any third-party claim that is subject to indemnification by you, in which event you will cooperate with us in asserting any available defenses."
                }
            ]
        },
        {
            title: "21. LIMITATION OF LIABILITY",
            content: [
                {
                    text: "NEITHER DAVINCI, ITS SERVICE PROVIDERS, OR ITS LICENSORS, NOR ANY OTHER PARTY INVOLVED IN CREATING, PRODUCING, OR DELIVERING THE SOFTWARE WILL BE LIABLE FOR ANY INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES, INCLUDING LOST PROFITS, LOSS OF DATA OR GOODWILL, SERVICE INTERRUPTION, COMPUTER DAMAGE, OR SYSTEM FAILURE OR THE COST OF SUBSTITUTE SOFTWARE ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OR FROM THE USE OF OR INABILITY TO USE THE SOFTWARE, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY, OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT DAVINCI HAS BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGE, EVEN IF A LIMITED REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE.",
                    newline: "16px"
                },
                {
                    text: "IN NO EVENT WILL DAVINCI’S TOTAL LIABILITY ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OR FROM THE USE OF OR INABILITY TO USE THE SOFTWARE OR SITES EXCEED TEN DOLLARS ($10). ANY CLAIM ARISING OUT OF OR RELATING TO YOUR USE OF THE SOFTWARE AND THE SITES MUST BE BROUGHT WITHIN ONE (1) YEAR OF THE DATE THAT THE CLAIM ACCRUES. THE FOREGOING LIMITATIONS WILL SURVIVE AND APPLY EVEN IF ANY LIMITED REMEDY SPECIFIED IN THESE TERMS IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE.",
                    newline: "16px"
                },
                {
                    text: "THE EXCLUSIONS AND LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE FUNDAMENTAL ELEMENTS OF THE BASIS OF THE BARGAIN BETWEEN DAVINCI AND YOU. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, SO THE ABOVE LIMITATION MAY NOT APPLY TO YOU."
                },
            ]
        },
        {
            title: "22. DISPUTE RESOLUTION",
            content: [
                {
                    text: "PLEASE READ THE FOLLOWING SECTION CAREFULLY BECAUSE IT REQUIRES YOU TO ARBITRATE CERTAIN DISPUTES AND CLAIMS WITH US AND LIMITS THE MANNER IN WHICH YOU CAN SEEK RELIEF FROM US.",
                    newline: "16px"
                },
                {
                    text: "You agree that any dispute between you and DaVinci arising out of or relating to these Terms, the Software, the Sites, or any other DaVinci Software or services (collectively, “",
                },
                {
                    text: "Disputes",
                    bold: true
                },
                {
                    text: "”) will be governed by the arbitration procedure outlined below.",
                    newline: "16px"
                },
                {
                    text: "Governing Law: Except as otherwise required by applicable law, the Terms and the resolution of any Disputes shall be governed by and construed in accordance with the laws of the State of North Carolina without regard to its conflict of laws principles. The United Nations Convention on Contracts for the International Sale of Goods shall not apply to these Terms or your use of the Sites or the Software.",
                    newline: "16px"
                },
                {
                    text: "Informal Dispute Resolution: We want to address your concerns without needing a formal legal case. Before filing a claim against DaVinci, you agree to try to resolve the Dispute informally by contacting us at ",
                    email: "support@davincilock.com"
                },
                {
                    text: ". We'll try to resolve the Dispute informally by contacting you through email. If a dispute is not resolved within 15 days after submission, you or DaVinci may bring a formal proceeding.",
                    newline: "16px"
                },
                {
                    text: "We Both Agree To Arbitrate: You and DaVinci agree to resolve any Disputes through final and binding arbitration, except as set forth under Exceptions to Agreement to Arbitrate below.",
                    newline: "16px"

                },
                {
                    text: "Opt-out of Agreement to Arbitrate: You can decline this agreement to arbitrate by contacting us at ",
                    email: "support@davincilock.com"
                },
                {
                    text: " within 30 days of first accepting these Terms and stating that you (include your first and last name) decline this arbitration agreement.",
                    newline: "16px"
                },
                {
                    text: "Arbitration Procedures: The American Arbitration Association (AAA) will administer the arbitration under its Commercial Arbitration Rules and the Supplementary Procedures for Consumer Related Disputes. The arbitration will be held in Raleigh, North Carolina, or any other location we agree to.",
                    newline: "16px"
                },
                {
                    text: "Arbitration Fees: The AAA rules will govern payment of all arbitration fees. DaVinci will not seek its attorneys' fees and costs in arbitration unless the arbitrator determines that your claim is frivolous.",
                    newline: "16px"
                },
                {
                    text: "Exceptions to Agreement to Arbitrate: Either you or DaVinci may assert claims, if they qualify, in small claims court in Raleigh, North Carolina. Either party may bring a lawsuit solely for injunctive relief to stop unauthorized use or abuse of the DaVinci Software or the Sites, or infringement of intellectual property rights (for example, trademark, trade secret, copyright or patent rights) without first engaging in arbitration or the informal dispute-resolution process described above.",
                    newline: "16px"
                },
                {
                    text: "No Class Actions: You may only resolve Disputes with DaVinci on an individual basis, and may not bring a claim as a plaintiff or a class member in a class, consolidated, or representative action. Class arbitrations, class actions, private attorney general actions, and consolidation with other arbitrations are not allowed under our agreement.",
                    newline: "16px"
                },
                {
                    text: "Judicial Forum for Disputes: Except as otherwise required by applicable law, in the event that the agreement to arbitrate is found not to apply to you or your claim, you and DaVinci agree that any judicial proceeding (other than small claims actions) will be brought in the federal or state courts located in Raleigh, North Carolina. Both you and DaVinci consent to venue and personal jurisdiction there. We each agree to waive our right to a jury trial.",
                    newline: "16px"
                },
                {
                    text: "Limitation on Claims: Regardless of any statute or law to the contrary, any claim or cause of action arising out of or related to your use of the DaVinci Software or the Sites must be filed within one (1) year after such claim or cause of action arose, or else that claim or cause of action will be barred forever."
                },
            ]
        },
        {
            title: "23. MARKETING",
            content: [
                {
                    text: "You agree that DaVinci may issue a press release regarding your use of the DaVinci Software. Further, DaVinci may publicly refer to you as a customer of DaVinci, including on DaVinci’s Sites and in sales presentations and may use your company logo for such purposes. You hereby grant DaVinci a worldwide, royalty-free, perpetual, irrevocable right and license to use your name and trademarks, including without limitation tradenames and logos, solely to advertise our goods and services and indicate that you are a customer of our business."
                }
            ]
        },
        {
            title: "24. GENERAL TERMS",
            content: [
                {
                    text: "Except as otherwise stated herein, these Terms constitute the entire and exclusive understanding and agreement between DaVinci and you regarding your use of the Sites, the Software and the DaVinci Content, and these Terms supersede and replace any and all prior oral or written understandings or agreements between DaVinci and you regarding your use of the Sites, the Software and the DaVinci Content.",
                    newline: "16px"
                },
                {
                    text: "We will notify you before we make material changes to these Terms and give you an opportunity to review the revised Terms before continuing to use the Software and the DaVinci Content. When you use the Software and the DaVinci Content after a modification becomes effective, you are telling us that you accept the modified Terms.",
                    newline: "16px"
                },
                {
                    text: "If for any reason a court of competent jurisdiction finds any provision of these Terms invalid or unenforceable, that provision will be enforced to the maximum extent permissible and the other provisions of these Terms will remain in full force and effect.",
                    newline: "16px"
                },
                {
                    text: "You may not assign, delegate, or transfer these Terms, by operation of law or otherwise, without DaVinci’s prior written consent. Any attempt by you to assign or transfer these Terms, without such consent, will be null. DaVinci may freely assign or transfer these Terms without restriction. Subject to the foregoing, these Terms will bind and inure to the benefit of the parties, their successors, and permitted assigns.",
                    newline: "16px"
                },
                {
                    text: "Any notices or other communications provided by DaVinci under these Terms, including those regarding modifications to these Terms, will be given: (i) via email, electronic communication, or text message, or (ii) by posting to the Sites. For notices made by e-mail, the date of receipt on the message will be deemed the date on which such notice is transmitted.",
                    newline: "16px"
                },
                {
                    text: "DaVinci’s failure to enforce any right or provision of these Terms will not be considered a waiver of such right or provision. The waiver of any such right or provision will be effective only if in writing and signed by a duly authorized representative of DaVinci. Except as expressly set forth in these Terms, the exercise by either party of any of its remedies under these Terms will be without prejudice to its other remedies under these Terms or otherwise."
                },
            ]
        },
        {
            content: [
                {
                    newline: "32px"
                },
                {
                    text: "CONTACT US",
                    newline: "16px"
                },
                {
                    text: "PLEASE CONTACT US IF YOU HAVE ANY QUESTIONS ABOUT THESE TERMS. You may contact us at ",
                    email: "support@davincilock.com"
                },
                {
                    text: ". or at our mailing address below.",
                    newline: "16px"
                },
                {
                    text: "DaVinci Lock, LLC",
                    newline: "0"
                },
                {
                    text: "3301 Atlantic Ave",
                    newline: "0"
                },
                {
                    text: "Raleigh, NC 27604",
                    newline: "32px"
                }
            ]
        },
        {
            content: [
                {
                    text: "EXHIBIT A",
                    center: true,
                    underline: true,
                    newline: "0"
                },
                {
                    text: "API LICENSE",
                    center: true,
                    newline: "16px"
                },
                {
                    type: "ol",
                    olType: "1",
                    items: [
                        {
                            content: [
                                {
                                    text: "Defined Terms",
                                    newline: "16px"
                                },
                                {
                                    type: "ol",
                                    olType: "a",
                                    items: [
                                        {
                                            content: [
                                                {
                                                    text: '"'
                                                },
                                                {
                                                    text: "API Key",
                                                    bold: true
                                                },
                                                {
                                                    text: '" means a unique number or token assigned to you by DaVinci which identifies you or your application and must be used in order to access the DaVinci Data and Content. An API Key is the property of DaVinci and may not be shared, publicly or privately distributed, or otherwise used except solely to exercise the licensed rights hereunder.',
                                                    newline: "16px"
                                                }
                                            ]
                                        },
                                        {
                                            content: [{
                                                text: '"'
                                            },
                                            {
                                                text: "DaVinci API",
                                                bold: true
                                            },
                                            {
                                                text: '" means a DaVinci Application Programming Interface that allows you to connect with and access the Software, the DaVinci Data and Content and any related documentation that is provided by DaVinci to assist you in its use of the DaVinci API.',
                                                newline: "16px"
                                            }]
                                        },
                                        {
                                            content: [{
                                                text: '"'
                                            },
                                            {
                                                text: "DaVinci Data and Content",
                                                bold: true
                                            },
                                            {
                                                text: '" means all programs, data, content, materials, processes, functionality, information and other matter that can be accessed with or by a DaVinci API, including without limitation data and content available on or through the DaVinci Software.',
                                                newline: "16px"
                                            }]
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "License. By using a DaVinci API or otherwise accessing the DaVinci Data and Content, you agree that such access and use is licensed under the following terms and conditions.",
                                    newline: "16px"
                                },
                                {
                                    type: "ol",
                                    olType: "a",
                                    items: [
                                        {
                                            content: [
                                                {
                                                    text: "DaVinci grants you a nonexclusive, non transferable, non sublicensable, revocable right and license, so long as DaVinci has not terminated your account or the API Key, which it may do at any time, to use the DaVinci API to access DaVinci Data and Content.",
                                                    newline: "16px"
                                                }
                                            ]
                                        },
                                        {
                                            content: [
                                                {
                                                    text: "you may use the DaVinci Data and Content obtained through the DaVinci API solely for your internal business purposes.",
                                                    newline: "16px"
                                                }
                                            ]
                                        },
                                        {
                                            content: [
                                                {
                                                    text: "you shall not share, publish, disclose or otherwise use the API Key except solely for accessing DaVinci Data and Content in accordance with the terms of this API License. you must promptly report to DaVinci any loss or suspected or actual misuse of an API Key and obtain a new one in such an event.",
                                                    newline: "16px"
                                                }
                                            ]
                                        },
                                        {
                                            content: [
                                                {
                                                    text: "you must not engage in any act that prevents DaVinci from logging the access or use of a DaVinci API, or otherwise circumvents the proper functioning of a DaVinci API.",
                                                    newline: "16px"
                                                }
                                            ]
                                        },
                                        {
                                            content: [
                                                {
                                                    text: "you will not use a DaVinci API or any DaVinci Data and Content to develop products or services that compete with the Software or any products or services offered by DaVinci or assist others in doing so.",
                                                    newline: "16px"
                                                }
                                            ]
                                        },
                                        {
                                            content: [
                                                {
                                                    text: "you shall not engage in hacking, penetration testing, security analysis, or any other effort to determine the security status of the Software or the DaVinci Data and Content. you shall not circumvent any access or copy controls placed on the Software or any DaVinci Data and Content or the DaVinci API. you will immediately report any actual or suspected unauthorized access of the Software or the DaVinci Data and Content.",
                                                    newline: "16px"
                                                }
                                            ]
                                        },
                                        {
                                            content: [
                                                {
                                                    text: "you will not use, and you will exert your best efforts but in no event less than reasonable care to prevent others from using, the DaVinci API and DaVinci Data and Content in any manner that violates any law, rule, or regulation.",
                                                    newline: "16px"
                                                }
                                            ]
                                        },
                                        {
                                            content: [
                                                {
                                                    text: "you will maintain standard server logs of your use of the DaVinci API for a period of not less than 90 days, which period may be extended by written notice from DaVinci if DaVinci is engaged in an investigation of the use of the DaVinci API.",
                                                    newline: "16px"
                                                }
                                            ]
                                        },
                                    ]
                                }
                            ]
                        },
                        {
                            content: [
                                {
                                    text: 'Modifications. you acknowledge and agree that DaVinci may modify (including but not limited to updating) the DaVinci Data and Content from time to time (a "'
                                },
                                {
                                    text: "Modification",
                                    bold: true
                                },
                                {
                                    text: '"). You will generally be notified about Modifications through notifications from DaVinci, though DaVinci is not obligated to do so. If you do not agree with any changes made by DaVinci, your sole remedy is to discontinue use of the DaVinci API. Your continued access to or use of the DaVinci API or any DaVinci Data and Content following such changes shall constitute binding acceptance of the applicable Modification(s). DaVinci will attempt, but is not obligated, to provide thirty (30) days’ notice of any Modification that DaVinci reasonably believes will remove or materially alter significant functionality of the DaVinci API.',
                                    newline: "16px"
                                }
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Ownership",
                                    newline: "16px"
                                },
                                {
                                    type: "ol",
                                    olType: "a",
                                    items: [
                                        {
                                            content: [
                                                {
                                                    text: "DaVinci. DaVinci and its licensors retain all worldwide right, title and interest in and to the API and the DaVinci Data and Content, including all worldwide intellectual property rights therein. As between you and DaVinci, DaVinci owns all right, title and interest in and to the DaVinci API and the DaVinci Data and Content and any derivative works or enhancements thereof, including but not limited to all worldwide intellectual property rights therein. Any of DaVinci's rights not expressly granted under this API License are withheld. You agree and covenant that you will not challenge DaVinci's ownership of the DaVinci API and the DaVinci Data and Content. If you acquire any rights in the DaVinci API or the DaVinci Data and Content, by operation of law or otherwise, you hereby assign and convey such rights to DaVinci for no additional consideration other than the rights granted to you herein.",
                                                    newline: "16px"
                                                }
                                            ]
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Support. This API License does not entitle you to any support for the DaVinci API, and any such support provided by DaVinci shall be provided at its sole discretion.",
                                    newline: "16px"
                                }
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Term.",
                                    newline: "16px"
                                },
                                {
                                    text: "DaVinci may terminate your right to use the API at any time by giving you written notice of termination not less than ninety (90) days prior to the effective date of the termination stated in such notice.",
                                    newline: "16px"
                                }
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Indemnification. you hereby agree to indemnify, defend and hold DaVinci, its subsidiaries, affiliates, officers, employees, and agents harmless from any and all claims, damages, losses, liabilities, actions, judgments, costs, and expenses brought by a third party arising out of or in connection with: (i) any act or omission by you in connection with your use of the DaVinci API or DaVinci Data and Content; (ii) your breach of applicable laws, rules, regulations or orders, or any third party obligations; or (iii) your negligence and willful misconduct.",
                                    newline: "16px"
                                }
                            ]
                        },
                        {
                            content: [
                                {
                                    text: 'Disclaimer. THE DAVINCI API AND THE DAVINCI DATA AND CONTENT ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. DAVINCI DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS, IMPLIED OR STATUTORY, REGARDING THE DAVINCI DATA AND CONTENT AND THE DAVINCI API, INCLUDING WITHOUT LIMITATION ANY AND ALL IMPLIED WARRANTIES OF MERCHANTABILITY, ACCURACY, RESULTS OF USE, RELIABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, INTERFERENCE WITH QUIET ENJOYMENT, NON-INFRINGEMENT OF THIRD-PARTY RIGHTS, ANY WARRANTIES OR CONDITIONS ARISING OUT OF COURSE OF DEALING OR USAGE OF TRADE. THERE IS NO WARRANTY THAT THE DAVINCI DATA AND CONTENT WILL FULFILL ANY PARTICULAR PURPOSES OR NEEDS THAT YOU MAY HAVE. FURTHER, DAVINCI DISCLAIMS ANY WARRANTY THAT YOUR USE OF THE DAVINCI DATA AND CONTENT OR THE API WILL MEET ANY OR ALL OF YOUR REQUIREMENTS OR THAT SUCH USE WILL BE UNINTERRUPTED, ERROR-FREE, VIRUS-FREE, OR SECURE.',
                                    newline: "32px"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            content: [
                {
                    text: "EXHIBIT B",
                    center: true,
                    underline: true,
                    newline: "0"
                },
                {
                    text: "DATA PROCESSING ADDENDUM",
                    center: true,
                    newline: "16px"
                },
                {
                    type: "ol",
                    olType: "A",
                    items: [
                        {
                            content: [
                                {
                                    text: "Processing: DaVinci shall Process Personal Data only as a Processor acting on Client’s documented instructions. DaVinci shall immediately inform Controller if, in its opinion, an instruction infringes on the GDPR or other Data Protection Laws or Regulations. Client shall at all times comply with its obligations as a Controller under Data Protection Laws and Regulations, including providing notice and obtaining all consents and authorizations necessary under Data Protection Laws and Regulations for DaVinci to Process such Personal Data on Client’s behalf. DaVinci shall Process Personal Data only for the purposes necessary to provide its services, or in accordance with Client’s written instructions, unless Processing is required by applicable law, in which case DaVinci shall, to the extent permitted by applicable laws, inform Client of that legal requirement before the Processing. Client acknowledges that DaVinci shall have the right to Process Personal Data in order to provide the contracted services, fulfill its obligations under any applicable agreement with Client, and for legitimate purposes relating to the operation, support and/or use of the services such as billing, account management, technical support, research, user experience and product development.",
                                    newline: "16px"
                                },
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Details of Personal Data Processing: The subject matter and duration of the Processing of the Personal Data are described in this DPA and any agreement between DaVinci and Client. The nature and purpose of the Processing of Personal Data is providing the DaVinci Software. The types of Personal Data that may be processed include name, contact information (such as email address); device information, such as device identifiers; and assessment results. The Processing of Personal Data pursuant to this DPA could pertain to employees or other workforce members of Client. The obligations and rights of Client are set forth in this DPA and any other agreement(s) between the parties.",
                                    newline: "16px"
                                },
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Data Security: DaVinci shall implement and maintain commercially reasonable technical and organizational security measures as required to comply with Article 32 of the GDPR. Notwithstanding the foregoing, Client agrees that except as provided by this Section 6, Client is responsible for the secure use of DaVinci services, such as security of account authentication credentials.",
                                    newline: "16px"
                                },
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Personal Data Breach: DaVinci shall notify Client without undue delay of any Personal Data Breach, as required by the Data Protection Laws and Regulations. This obligation shall not apply to incidents that are caused by Client, including Client’s employees or agents. Client shall be solely responsible for notifying any Supervisory Authorities and Data Subjects of any Personal Data Breach and all costs associated with same.",
                                    newline: "16px"
                                },
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Confidentiality of Data Processing: DaVinci shall ensure that any person authorized by DaVinci to Process Personal Data (including staff), are under an appropriate obligation of confidentiality (whether a contractual or statutory duty).",
                                    newline: "16px"
                                },
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Return or Deletion of Data: Upon termination or expiration of the an agreement between the parties, DaVinci shall (at Client's election) delete or return, if feasible, to Client all Personal Data remaining in its possession or control, save that this requirement shall not apply: (i) to the extent DaVinci is required by applicable law to retain some or all of the Personal Data; (ii) if DaVinci is reasonably required to retain some or all of the Personal Data for limited operational and compliance purposes; or (iii) to Personal Data Career key has archived on back-up systems. The terms of this Section 6 shall survive for as long as DaVinci continues to retain any Personal Data.",
                                    newline: "16px"
                                },
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Subprocessing:  Client agrees that this Exhibit constitutes Client’s written authorization for DaVinci to engage Subprocessors to Process Personal Data on Client's behalf, including the Subprocessors currently engaged by DaVinci. DaVinci shall: (i) enter into a written agreement with the Subprocessor that requires the Subprocessor to protect the Personal Data to the standard required by Data Protection Laws and Regulations; (ii) remain responsible for its compliance with the obligations of this Section 6 and for any acts or omissions of the Subprocessor that cause DaVinci to breach any of its obligations under this Section 6; and (iii) notify Client in the event that it intends to engage different or additional Subprocessors that will Process Personal Data.",
                                    newline: "16px"
                                },
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Individual Rights, Controller Obligations, and Supervisory Authority Inquiries: DaVinci shall comply with Client’s commercially reasonable requests to assist Client in fulfilling its obligations to Data Subjects’ exercise of their individual rights, and ensuring compliance with Controller’s obligations under Articles 32 to 36 of GDPR, if such assistance by DaVinci is strictly necessary and Client is unable to independently fulfill these obligations without DaVinci’s support. To the extent legally permitted, DaVinci shall notify Client if it receives a request from a Supervisory Authority, and shall provide commercially reasonable cooperation to assist Client in its response to such Supervisory Authority to the extent strictly necessary. Client shall bear all of DaVinci’s costs and expenses for providing assistance under this Subsection H.",
                                    newline: "16px"
                                },
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Demonstrating Compliance: DaVinci shall provide written responses (on a confidential basis) to all commercially reasonable requests for information made by Client regarding Processing of Personal Data, including responses to information security reviews, that are necessary to confirm DaVinci’s compliance with the terms of this Section 6. DaVinci shall allow for and contribute to audits and inspections performed by Client or a vendor of Client reasonably acceptable to DaVinci, provided that no on-site audits may be conducted unless necessary to demonstrate DaVinci’s compliance with this Section 6, and Client reasonably believes that DaVinci is not complying with this Section 6. Any audit or inspection, whether on-site or remove, shall be conducted at Client’s sole cost and expense, and in a manner that does not cause any damage, injury, or disruption to DaVinci’s premises, equipment, personnel, or business. Under no circumstance shall DaVinci be required to disclose any proprietary or privileged information to Client or an agent or vendor of Client. Client shall not exercise its rights under this section more than once annually, including with respect to any support required to perform a data protection impact assessment.",
                                    newline: "16px"
                                },
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Data Transfers: DaVinci may Process Personal Data anywhere in the world where DaVinci or its Subprocessors maintain data Processing operations. DaVinci shall at all times provide an adequate level of protection for the Personal Data Processed, in accordance with the requirements of Data Protection Laws and Regulations. The parties agree that this Section 6 constitutes appropriate safeguards to transfer Personal Data to a third country pursuant to Article 46 of the GDPR.  In the event DaVinci will Process Personal Data in a country that has not been designated by the European Commission or Swiss Federal Data Protection Authority (as applicable) as providing an adequate level of protection for Personal Data, Client, as data exporter, and DaVinci, as data importer, agree to abide by the applicable provisions of the European Commission standard contractual clauses, available at ",
                                },
                                {
                                    links: ["https://eur-lex.europa.eu/legal-content/en/TXT/?uri=CELEX%3A32010D0087"]
                                },
                                {
                                    text: " which are hereby incorporated by reference into this DPA. Appendix 1 and Appendix 2 of the standard contractual clauses are included below:",
                                    newline: "16px"
                                },
                                {
                                    text: "APPENDIX 1 TO THE STANDARD CONTRACTUAL CLAUSES",
                                    center: true,
                                    bold: true,
                                    newline: "16px"
                                },
                                {
                                    text: "This Appendix forms part of the Clauses and must be completed and signed by the parties.",
                                    newline: "0"
                                },
                                {
                                    text: "The Member States may complete or specify, according to their national procedures, any additional necessary information to be contained in this Appendix.",
                                    newline: "16px"
                                },
                                {
                                    text: "Data exporter",
                                    bold: true,
                                    newline: "0"
                                },
                                {
                                    text: "The data exporter is (please specify briefly your activities relevant to the transfer): The data exporter has contracted to use a technology platform and services provided by data importer to offer career assessment services to the members of data exporter’s organization.",
                                    newline: "16px"
                                },
                                {
                                    text: "Data importer",
                                    bold: true,
                                    newline: "0"
                                },
                                {
                                    text: "The data importer is (please specify briefly activities relevant to the transfer): The data importer provides a technology platform and software to provide career assessment services to the members of data exporter’s organization.",
                                    newline: "16px"
                                },
                                {
                                    text: "Data subjects",
                                    bold: true,
                                    newline: "0"
                                },
                                {
                                    text: "The personal data transferred concern the following categories of data subjects (please specify): The data subjects are members of the data exporter’s organization. Depending on the nature of the data exporter’s organization, the data subjects may include employees, or other members of the data exporter’s organization.",
                                    newline: "16px"
                                },
                                {
                                    text: "Categories of data",
                                    bold: true,
                                    newline: "0"
                                },
                                {
                                    text: "The personal data transferred concern the following categories of data (please specify): The personal data will include contact information such as the data subject’s name, email, or identification number, device information, such as device identifiers, and assessment results.",
                                    newline: "16px"
                                },
                                {
                                    text: "Special categories of data (if appropriate)",
                                    bold: true,
                                    newline: "0"
                                },
                                {
                                    text: "The personal data transferred concern the following special categories of data (please specify):  None.",
                                    newline: "16px"
                                },
                                {
                                    text: "Processing operations",
                                    bold: true,
                                    newline: "0"
                                },
                                {
                                    text: "The personal data transferred will be subject to the following basic processing activities (please specify): The personal data will be processed for purposes of communicating or making information available to the data exporter and data subjects, providing services to the data exporter and data subjects, and to enhance data importer’s products and services.",
                                    newline: "32px"
                                },
                                {
                                    text: "APPENDIX 2 TO THE STANDARD CONTRACTUAL CLAUSES",
                                    center: true,
                                    bold: true,
                                    newline: "16px"
                                },
                                {
                                    text: "This Appendix forms part of the Clauses and must be completed and signed by the parties.",
                                    newline: "0"
                                },
                                {
                                    text: "Description of the technical and organizational security measures implemented by the data importer in accordance with Clauses 4(d) and 5(c) (or document/legislation attached):",
                                    bold: true,
                                    newline: "0"
                                },
                                {
                                    text: "Security measures implemented include administrative safeguards such as security policies and procedures and determination of access rights and security clearances. Technical safeguards include logging and monitoring of system activity and access, intrusion detection, access controls, firewalls, and change management controls.",
                                    newline: "16px"
                                }
                            ]
                        },
                        {
                            content: [
                                {
                                    text: "Client Obligations and Indemnification: Client shall ensure that Client is entitled to transfer the relevant Personal Data to DaVinci for Processing as set forth in this Section 6. Client shall not provide to DaVinci any “Sensitive Personal Data” as defined by GDPR and any Data Protection Laws and Regulations, including racial or ethnic origin, political opinions, religious beliefs, trade union membership, physical or mental health or condition, sexual life, or the commission or alleged commission of any crime or offense. Client shall ensure that the relevant third parties have been informed of, and have given their consent to, such use, processing, and transfer as required by any applicable Data Protection Laws and Regulations and acknowledges that DaVinci is reliant on Client for direction as to the extent to which DaVinci is entitled to use and Process the Personal Data. Client shall ensure that the relevant third parties and Data Subjects have been informed of, and have given their consent to, such use, processing, and transfer, as required by any applicable Data Protection Laws and Regulations and acknowledges that DaVinci is reliant on Client for direction as to the extent to which DaVinci is entitled to use and process the Personal Data. Consequently, DaVinci will not be liable for any claim brought against DaVinci arising from any action or omission by DaVinci to the extent that such action or omission resulted directly from Client’s instructions and/or any failure of Client to comply with this Section 6. In addition to, and without limiting any indemnification obligations in this DPA, Client shall indemnify, and keep indemnified, DaVinci against all claims, damages, expenses, penalties, and fines incurred by DaVinci or in respect of which DaVinci may become liable due to any failure by Client or its employees or agents to comply with its obligations under this Section 6."
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}
